import { render, staticRenderFns } from "./wei.vue?vue&type=template&id=213c621b&scoped=true"
import script from "./wei.vue?vue&type=script&lang=js"
export * from "./wei.vue?vue&type=script&lang=js"
import style0 from "./wei.vue?vue&type=style&index=0&id=213c621b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c621b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213c621b')) {
      api.createRecord('213c621b', component.options)
    } else {
      api.reload('213c621b', component.options)
    }
    module.hot.accept("./wei.vue?vue&type=template&id=213c621b&scoped=true", function () {
      api.rerender('213c621b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/index/wei.vue"
export default component.exports